
/**
-------------------------------
GIFT WITH PURCHASE EXTENSION
-------------------------------

MARKETING TEAM CAN SPECIFY A PRODUCT IN SHOPIFY ADMIN THAT IS AUTOMATICALLY
ADDED TO CART ONCE THE CONSUMER AGREES TO PURCHASE A MINIMUM AMOUNT OF MERCHANDISE

IAIN MCQUEEN
mcqueen.iain@gmail.com

**/

(function(){
	//IMPORT GIFT WITH PURCHASE SETTINGS FROM CONFIG_SETTINGS.JSON
	var GWP_ACTIVE = false
	, GWP_THRESHOLD = parseInt('9999999999')
	, GWP_TRIGGER = ''
	, GWP_PRODUCT_TYPE_TRIGGER = 'bundle,FS'
	, GWP_VARIANT_TRIGGER_1 = '32275985006685'
	, GWP_VARIANT_TRIGGER_2 = '32276082786397'
	, GWP_FREE_GIFT_1 = '32954643906653'
	, GWP_FREE_GIFT_2 = '32954645839965'
	, GWP_VARIANT = ""+ parseInt('37526397878455');
	var GWP = function(opts){
		for( var opt in opts){
			this[opt] = opts[opt];
		}
	};

	GWP.prototype = {
		active: false,
		variant: 0,
		threshold: 0,
		product_trigger: false,
		product_type_trigger: false,
		addGiftWithPurchase: function(callback){
			var variant = this.variant
			,price_threshold_cents = this.threshold
			,product_trigger = this.product_trigger
			,product_type_trigger = this.product_type_trigger
			,product_variant_trigger_1 = this.product_variant_trigger_1
			,product_variant_trigger_2 = this.product_variant_trigger_2
			,product_free_gift_1 = this.product_free_gift_1
			,product_free_gift_2 = this.product_free_gift_2

			,item_in_cart = false
			, item_being_added = false;
			//CONFIRM A GWP PROMOTION IS ACTIVE
			if( !this.active ) return callback();

			var checkForGWPItem = function(data){
				//disabled as not active promo
				//CART SATISFIES SPEND THRESHOLD AND NO PRODUCT TRIGGER IS SET?
				// if(data.total_price >= price_threshold_cents && !product_trigger && !product_type_trigger){
				// 	//CHECK IF FREE VARIANT IS ALREADY IN THE CART
				// 	item_in_cart = data.items.find(function(item){ return item.variant_id == variant; })
				// 	//IF ITEM IS NOT IN CART, ADD THE FREE GIFT VARIANT
				// 	if(!item_in_cart){
				// 		item_being_added =true;
				// 		$.ajax({
				// 			type: "POST",
				// 			url: "/cart/add.js",
				// 			data: { quantity:1, id: variant},
				// 			success: function(){ callback() },
				// 			dataType: "json"
				// 		});
				// 	}
				// }

				// if(product_type_trigger || product_trigger){
				// 	var product_type_triggers = product_type_trigger.split(",");
				// 	//CART HAS TRIGGER IN CART
				// 	trigger_in_cart = data.items.find(function(item){ return item.product_id == product_trigger || (product_type_triggers.indexOf(item.product_type) > -1 && item.variant_id != variant);})
				// 	if(trigger_in_cart){
				// 		//CHECK IF FREE VARIANT IS ALREADY IN THE CART
				// 		item_in_cart = data.items.find(function(item){ return item.variant_id == variant; })
				// 		//IF ITEM IS NOT IN CART, ADD THE FREE GIFT VARIANT
				// 		if(!item_in_cart){
				// 			item_being_added = true;
				// 			$.ajax({
				// 				type: "POST",
				// 				url: "/cart/add.js",
				// 				data: { quantity:1, id: variant},
				// 				success: function(){ callback() },
				// 				dataType: "json"
				// 			});
				// 		}
				// 	}else{
				// 		item_in_cart = data.items.find(function(item){ return item.variant_id == variant; });
				// 		//FREE VARIANT IS IN CART WHEN IT SHOULDNT BE. REMOVE IT
				// 		if(item_in_cart){
				// 			item_being_added = true;
				// 			$.ajax({
				// 				type: "POST",
				// 				url: "/cart/change.js",
				// 				data: { quantity:0, id: variant},
				// 				success: function(){ callback() },
				// 				dataType: "json"
				// 			});
				// 		}
				// 	}
				// }
				if(product_variant_trigger_1){
					item_in_cart = data.items.find(function(item){return item.variant_id == product_variant_trigger_1; })
					//IF ITEM IS NOT IN CART, ADD THE FREE GIFT VARIANT
					if(item_in_cart){
						item_being_added =true;
						console.log(product_free_gift_1);
						$.ajax({
							type: "POST",
							url: "/cart/add.js",
							data: { quantity:1, id: product_free_gift_1},
							success: function(){ checkForProduct2(data) },
							dataType: "json"
						});
					}else{
						item_being_added = true;
						$.ajax({
							type: "POST",
							url: "/cart/change.js",
							data: { quantity:0, id: product_free_gift_1},
							success: function(){ checkForProduct2(data) },
							dataType: "json"
						});
					}
				}





			}

			var checkForProduct2 = function(data){
				if(product_variant_trigger_2){
					item_in_cart = data.items.find(function(item){return item.variant_id == product_variant_trigger_2; })
					//IF ITEM IS NOT IN CART, ADD THE FREE GIFT VARIANT
					if(item_in_cart){
						item_being_added =true;
						console.log(product_free_gift_2);
						$.ajax({
							type: "POST",
							url: "/cart/add.js",
							data: { quantity:1, id: product_free_gift_2},
							success: function(){ callback() },
							dataType: "json"
						});
					}else{
						item_being_added = true;
						$.ajax({
							type: "POST",
							url: "/cart/change.js",
							data: { quantity:0, id: product_free_gift_2},
							success: function(){ callback() },
							dataType: "json"
						});
					}
				}
				//ONLY RUN THIS IF THE ITEM ISNT BEING ADDED, OTHERWISE IT WILL RUN AT THE END
				if(!item_being_added) callback();

			}

			//RETRIEVE THE CURRENT CART CONTENTS
			$.ajax({
				url:"/cart.js",
				dataType:"json",
				type:"get",
				success: checkForGWPItem
			});
		}
	}
	var giftWithPurchase = new GWP({
		active: GWP_ACTIVE,
		threshold: GWP_THRESHOLD,
		variant: GWP_VARIANT,
		product_trigger: GWP_TRIGGER,
		product_type_trigger: GWP_PRODUCT_TYPE_TRIGGER,
		product_variant_trigger_1: GWP_VARIANT_TRIGGER_1,
		product_variant_trigger_2: GWP_VARIANT_TRIGGER_2,
		product_free_gift_1: GWP_FREE_GIFT_1,
		product_free_gift_2: GWP_FREE_GIFT_2

	})
	window.GWP = giftWithPurchase;
})();
